import { useLocation } from 'react-router-dom';

import { useGetIwocapayReferrer } from '../../../api/lending/lapiHooks';

export const REFERRAL_CODE_STORAGE_KEY = 'referral_code';

export function useReferralCode() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referral_code = queryParams.get(REFERRAL_CODE_STORAGE_KEY);

  const { iwocapayReferrer, iwocapayReferrerError } = useGetIwocapayReferrer({
    referralCode: referral_code,
    onSuccess: () => {
      sessionStorage.setItem(REFERRAL_CODE_STORAGE_KEY, referral_code!);
    },
  });

  return {
    referrerName: iwocapayReferrer?.referrer_name || null,
    error: iwocapayReferrerError,
  };
}
